import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { siteQueries } from '../../api/resources/site';
import { Select } from '../../components/ui/Select';
import { canonicalCountryCode } from '../../lib/format';
import { useLocale } from '../../lib/useLocale';

export function CountrySelect({
  value,
  onChange,
  id,
  size = 'md',
}: {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  size?: 'sm' | 'md';
}) {
  const { t, locale, flag } = useLocale();
  const countries = useQuery(siteQueries.countries());

  const options = useMemo(() => {
    const items = (countries.data ?? []).filter((item) => {
      const code = item.code.trim().toUpperCase();
      return code !== 'TW' && code !== 'TWN' && code !== 'HK' && code !== 'HKG' && code !== 'MO' && code !== 'MAC';
    });
    return items
      .map((item) => ({
        value: item.code,
        label: `${flag(item.code)}  ${locale === 'zh' ? item.nameZh : item.nameEn}`,
      }))
      .sort((a, b) => String(a.label).localeCompare(String(b.label), locale === 'zh' ? 'zh-CN' : 'en-US'));
  }, [countries.data, flag, locale]);

  return (
    <Select
      id={id}
      size={size}
      value={canonicalCountryCode(value) ?? ''}
      onValueChange={onChange}
      placeholder={t('auth.countryPlaceholder')}
      options={options}
      aria-label={t('auth.country')}
    />
  );
}
